import { LuExternalLink } from "react-icons/lu";

import { DEFAULT_POST_DATE_FORMAT, FocusDateParser } from "@/utils/date";
import { shortenLongWord } from "@/utils/helpers";
import { cn } from "@/utils/lib";

import CopyToClipboard from "./copy-to-clipboard";

const TransactionCopyToClipboard = ({
  transactionHash,
  timestamp = "",
  txnClassName = "",
}: {
  transactionHash: string;
  timestamp?: string;
  txnClassName?: string;
}) => {
  return (
    <div className="flex flex-col items-start">
      <CopyToClipboard
        text={transactionHash}
        iconPosition="right"
        showToast
        toastText="Transaction Hash copied to clipboard!"
      >
        <div className={cn("text-sm font-medium", txnClassName)}>
          {shortenLongWord(transactionHash, 5, 5)}
        </div>
        <a
          href={`${process.env.NEXT_PUBLIC_EXPLORER_URI}/txn/${transactionHash}`}
          target="blank"
          title="View on explorer"
        >
          <LuExternalLink size={16} />
        </a>
      </CopyToClipboard>
      <div className="text-xs text-muted">
        {FocusDateParser.formatUTCDate(
          timestamp,
          DEFAULT_POST_DATE_FORMAT,
          "Pending...",
        )}
      </div>
    </div>
  );
};
export default TransactionCopyToClipboard;
